export const generateHueFromTitle = (title) => {
    let hash = 0;
    for (let i = 0; i < title.length; i++) {
        hash = title.charCodeAt(i) + ((hash << 5) - hash);
    }
    return ((hash % 360) + 360) % 360;
}

export const generateColorFromTitle = (title, mode = 'light', lightNess = 90) => {
    let hash = 0;
    for (let i = 0; i < title.length; i++) {
        hash = title.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;
    const s = 70;
    const l = lightNess;

    if (mode === 'dark') {
        const { r, g, b } = backgroundHslToRgb(h / 360, s / 100, l / 100);
        return `rgba(${r}, ${g}, ${b}, 0.15)`; 
    }

    return `hsl(${h}, ${s}%, ${l}%)`;
}

export const generateIconColorFromTitle = (title, mode = 'light') => {
    let hash = 0;
    for (let i = 0; i < title.length; i++) {
        hash = title.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;

    if (mode === 'dark') {
        return `hsl(${h}, ${70}%, ${90}%)`;
    }

    return `hsl(${h}, 80%, 30%)`;
}

function backgroundHslToRgb(h, s, l) {
    let r, g, b;

    if (s === 0) {
        r = g = b = l;
    } else {
        const hue2rgb = (p, q, t) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }

    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255),
    };
}